import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';
import { isPossiblePhoneNumber } from 'react-phone-number-input';

const phoneUtil = PhoneNumberUtil.getInstance();

export const safePhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber) {
    return phoneNumber;
  }

  if (phoneNumber.startsWith('+') && isPossiblePhoneNumber(phoneNumber)) {
    // For all numbers: return clean E.164 format (includes country code)
    try {
      const formatted = phoneUtil.format(phoneUtil.parse(phoneNumber), PhoneNumberFormat.E164);
      return formatted;
    } catch (error) {
      // If formatting fails, return original number
      return phoneNumber;
    }
  }

  return phoneNumber;
};

export const safeParsePhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber) {
    return phoneNumber;
  }

  // If already has + prefix, return as-is
  if (phoneNumber.startsWith('+')) {
    return phoneNumber;
  }

  // Check for US/CA 10-digit numbers FIRST (before trying international parsing)
  // This prevents "7543526637" from being parsed as "+7..." (Russia country code)
  if (phoneNumber.length === 10 && /^\d{10}$/.test(phoneNumber)) {
    if (isPossiblePhoneNumber(`+1${phoneNumber}`)) {
      return `+1${phoneNumber}`;
    }
  }

  // Try parsing as international number with + prepended
  try {
    const numberWithPlus = '+' + phoneNumber;
    const parsedNumber = phoneUtil.parse(numberWithPlus);

    // Return in E.164 format even if not valid, as long as it parsed successfully
    // This ensures the country code is properly detected by the UI component
    return phoneUtil.format(parsedNumber, PhoneNumberFormat.E164);
  } catch (error) {
    // Could not parse, continue to fallback
  }

  // Return with + prepended for other cases (helps UI detect country)
  return phoneNumber.startsWith('+') ? phoneNumber : `+${phoneNumber}`;
};
